<div class="card">
  <div class="card-info">
    <div class="tw-flex tw-items-center tw-space-x-4">
      <div
        class="tw-h-12 tw-w-12 tw-flex tw-items-center tw-justify-center tw-text-lg tw-font-semibold tw-rounded-full tw-overflow-hidden"
      >
        <img
          [src]="photo"
          class="tw-w-full tw-h-full tw-object-cover"
          alt="User photo"
        />
      </div>
      <div class="tw-min-w-0"> <!-- Contenedor para evitar expansión -->
        <div class="tw-text-white tw-font-medium tw-text-base md:tw-text-lg tw-truncate">
          {{ name }}
        </div>
      </div>
    </div>

    <p class="tw-text-white tw-mt-2 tw-text-sm md:tw-text-base tw-line-clamp-3">
      {{ text }}
    </p>

    <div class="tw-font-medium tw-mt-2">
      <div class="star-rating tw-flex tw-text-xl tw-relative">
        <ng-container *ngFor="let star of filledStars">
          <i class="bi bi-star-fill"></i>
        </ng-container>
        <ng-container *ngFor="let star of emptyStars">
          <i class="bi bi-star"></i>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<style>
  .card {
    --background: linear-gradient(45deg, #0000ff, #f67011);
    padding: 2px;
    border-radius: 25px;
    background: #181818;
    position: relative;
    z-index: 1;
    overflow: hidden;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    transition: transform 0.3s ease;
    height: 250px; /* Altura fija */
  }

  .card::before {
    content: "";
    position: absolute;
    z-index: -2;
    left: -50%;
    top: -50%;
    width: 200%;
    height: 200%;
    background: var(--background);
    animation: rotate 4s linear infinite;
  }

  .card::after {
    position: absolute;
    content: "";
    top: 2px;
    left: 2px;
    right: 2px;
    bottom: 2px;
    z-index: -1;
    border-radius: 23px;
    background: #181818;
  }

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes rating-fill {
    0% {
      width: 0%;
    }
    100% {
      width: 100%;
    }
  }

  .card-info {
    background: #181818;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    overflow: hidden;
    border-radius: 23px;
    padding: 20px;
    position: relative;
    z-index: 1;
  }

  .star-rating {
    display: inline-block;
    position: relative;
    height: 1em;
    line-height: 1;
  }

  .tw-animate-rating {
    animation: rating-fill 1s ease-out forwards;
  }

  /* Estilos para truncar texto */
  .tw-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* Estilos para limitar líneas de texto */
  .tw-line-clamp-3 {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  @media (max-width: 640px) {
    .card {
      height: 220px; /* Altura ajustada para móviles */
    }
    
    .card-info {
      padding: 15px;
    }

    .tw-flex.tw-space-x-4 {
      gap: 12px;
    }

    .tw-h-12,
    .tw-w-12 {
      height: 40px;
      width: 40px;
    }
  }

  @media (max-width: 400px) {
    .card {
      height: 200px; /* Altura más pequeña para pantallas muy pequeñas */
    }
    
    .card-info {
      padding: 12px;
    }

    p.tw-text-white {
      font-size: 0.875rem;
    }
  }
</style>